





























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

@Component({
  components: {
    LoadingBlock,
    ScreenSizeVisibility,
  }
})
export default class InvoiceDetailsLoading extends Vue {
  @Prop({default: false}) private readonly showTitle: boolean;
  @Prop({default: false}) private isRenewal: boolean;

  private get title(): any {
    const title = !this.isRenewal
      ? 'App.Checkout.Offer.summary'
      : 'App.Checkout.Offer.renew.summary';

    return this.$t(title);
  }
}
